
  import createMeisterIcons from '../src/createMeisterIcons';

  const Switch = createMeisterIcons("switch", [["path",{"fill":"currentColor","d":"M3.75 12c0-2.386 1.864-4.25 4.25-4.25h8c2.386 0 4.25 1.864 4.25 4.25s-1.864 4.25-4.25 4.25H8c-2.376 0-4.25-1.954-4.25-4.25M8 6.25c-3.214 0-5.75 2.536-5.75 5.75 0 3.104 2.526 5.75 5.75 5.75h8c3.214 0 5.75-2.536 5.75-5.75S19.214 6.25 16 6.25zM6.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M8 9.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5","key":"c079a67836d8365dff95d0e7401c2619ba267f76","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Switch
  